<template>
	<div class="row justify-content-center">
		<div class="col-md-12">
			<div class="card">
				<div class="card-header">Import gift card list</div>
				<div class="card-body">
					<div class="form-group">
						<label>Import file</label>
						<div class="custom-file">
							<input type="file" name="attachment" class="form-control" id="gift_card_file" @change="onFileChange" ref="file">
							<label class="custom-file-label" for="gift_card_file">{{ (fileName) ? fileName : 'Choose file' }}</label>
						</div>
						<div v-if="errors && errors.data" class="text-danger">{{ errors.data[0] }}</div>
					</div>
					<div class="form-group">
						<label for="customer_name">Customer name</label>
						<input type="text" name="customer_name" class="form-control" id="customer_name" v-model="customer_name">
						<div v-if="errors && errors.customer_name" class="text-danger">{{ errors.customer_name[0] }}</div>
					</div>
				</div>
				<div class="modal-footer">
					<button v-if="isLoading === false" type="button" class="btn btn-primary" @click="onConfirm" :disabled="attachment === null || customer_name === null">Upload</button>
					<button v-else class="btn btn-primary" type="button" disabled>
						<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
						Loading...
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	components: {},
	data() {
		return {
			fileType: 'gift_card_list',
			fileName: '',
			description: null,
			attachment: null,
			errors: {},
			isLoading: false,
			customer_name: null
		}
	},
	methods: {
		onFileChange(e){

			let files = e.target.files || e.dataTransfer.files;
			let reader = new FileReader();

			reader.readAsDataURL(files[0]);
			reader.onload = (e) => {
				this.attachment = e.target.result;

			};

			this.fileName = this.$refs.file.files[0].name;
			this.errors = {};
		},
		async onConfirm() {

			this.isLoading = true;

			await axios.post('/import', {data: this.attachment, customer_name: this.customer_name, file_type: this.fileType}).then(response => {
				window.location = '/import/' + response.data.id +  '/map-fields';
			}).catch(error => {

				this.isLoading = false;

				if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

			});

		}
	}
}
</script>